[
  {
    "code": "AUTONOMO",
    "label": {
      "en": "Self-employed",
      "es": "Autonomo"
    },
    "order": 1,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Individual self-employed worker",
        "es": "Trabajador por cuenta propia"
      }
    }
  },
  {
    "code": "SL",
    "label": {
      "en": "Limited Company (SL)",
      "es": "Sociedad Limitada (SL)"
    },
    "order": 2,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Limited liability company",
        "es": "Sociedad de responsabilidad limitada"
      }
    }
  },
  {
    "code": "SLU",
    "label": {
      "en": "Single-member Ltd (SLU)",
      "es": "Sociedad Limitada Unipersonal (SLU)"
    },
    "order": 3,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Single-member limited company",
        "es": "SL con un unico socio"
      }
    }
  },
  {
    "code": "SA",
    "label": {
      "en": "Corporation (SA)",
      "es": "Sociedad Anonima (SA)"
    },
    "order": 4,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Public limited company",
        "es": "Sociedad por acciones"
      }
    }
  },
  {
    "code": "COOP",
    "label": {
      "en": "Cooperative",
      "es": "Cooperativa"
    },
    "order": 5,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Worker-owned cooperative",
        "es": "Sociedad cooperativa"
      }
    }
  },
  {
    "code": "CB",
    "label": {
      "en": "Community of Goods",
      "es": "Comunidad de Bienes (CB)"
    },
    "order": 6,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Partnership without legal entity",
        "es": "Agrupacion sin personalidad juridica"
      }
    }
  },
  {
    "code": "SC",
    "label": {
      "en": "Civil Partnership",
      "es": "Sociedad Civil (SC)"
    },
    "order": 7,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Civil partnership",
        "es": "Sociedad civil privada"
      }
    }
  },
  {
    "code": "ASSOC",
    "label": {
      "en": "Association",
      "es": "Asociacion"
    },
    "order": 8,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Non-profit association",
        "es": "Asociacion sin animo de lucro"
      }
    }
  },
  {
    "code": "FOUND",
    "label": {
      "en": "Foundation",
      "es": "Fundacion"
    },
    "order": 9,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Non-profit foundation",
        "es": "Fundacion sin animo de lucro"
      }
    }
  },
  {
    "code": "OTHER",
    "label": {
      "en": "Other",
      "es": "Otros"
    },
    "order": 99,
    "is_active": true,
    "metadata": {
      "description": {
        "en": "Other legal form",
        "es": "Otra forma juridica"
      }
    }
  }
]
